import React from 'react'
import FullCalendar, { formatDate } from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS, createEventId } from '../components/event-utils'
import { Grid } from '@mui/material';
import esLocale from '@fullcalendar/core/locales/es';
import DeleteIcon from '@mui/icons-material/Delete';
import {SecondaryIconButton, SecondaryButton, SuccessAlert} from '../theme/index';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { multiBookingAction, showMessageAction } from '../redux/reducers/MultiBooking';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import DangerModal from '../components/DangerModal';
import { modalDeleteAction } from '../redux/reducers/Modal'

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor:  theme.palette.primary.light,
    color: '#000',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

const MultiBooking = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showMessage, setShowMessage] = React.useState(false);
  const [ showDeleteModal, setShowDeleteModal ] = React.useState(false);

  const messageState = useSelector(state => state.MultiBooking.showMessage);
  const deleteModalState = useSelector( state => state.Modal.deleteModalState );

  React.useEffect( () => {
    setShowDeleteModal(deleteModalState);
  }, [deleteModalState] );
  


  React.useEffect( () => {
    setShowMessage(messageState);

    if( messageState ){
      setTimeout(() => {
        dispatch(showMessageAction());
        setShowMessage(false);
      }, 3000)
    }
  },[] );


  const [state, setState] = React.useState({
    weekendsVisible: true,
    currentEvents: []
  });

  const handleWeekendsToggle = () => {
    setState({
      weekendsVisible: !this.state.weekendsVisible
    })
  }

  const checkDate = (checkIn, checkOut) => {
    const currentDate = moment().format('YYYY-MM-DD');
    return ( !(moment(currentDate).isAfter(checkIn, 'day')) && !(moment(currentDate).isAfter(checkOut, 'day')) ) ? false : true ;
  }

  const handleDateSelect = (selectInfo) => {
    if( checkDate(selectInfo.startStr, selectInfo.endStr) ){
      dispatch(modalDeleteAction());
    }else{
      let title = prompt('Please enter a new title for your event')
      let calendarApi = selectInfo.view.calendar
  
      calendarApi.unselect() // clear date selection
  
      if (title) {
        calendarApi.addEvent({
          id: createEventId(),
          title,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay
        })
      }
    }
  }

  const handleEventClick = (clickInfo) => {
    console.log(clickInfo);
    //clickInfo.event.remove()
  }

  const handleEvents = (events) => {
    setState({
      currentEvents: events
    })
  }

  const renderEventContent = (eventInfo) => {
    return (
      <>
        <b>{eventInfo.timeText}</b>
        <HtmlTooltip
          placement="top"
          title={
            <>
              <b>{'Cliente'}</b>
              <Typography color="inherit">Nombre: Alejandro Perez</Typography>
              <Typography color="inherit">Habitacion: Matrimonial</Typography>
              <Typography color="inherit">Nº Hab: 002</Typography>
            </>
          }
        >
          <i>{eventInfo.event.title}</i>
        </HtmlTooltip>
      </>
    )
  }

  const renderSidebarEvent = (event) => {
    return (
      <li key={event.id} style={{ marginBottom: '1rem' }}>
        <b>{event.startStr} - {event.endStr} </b>
        <i>
          <SecondaryIconButton aria-label="delete" onClick={ () => event.remove() }>
            <DeleteIcon />
          </SecondaryIconButton>  
        </i>
      </li>
    )
  }

  const createReservations = (events) => {
    const eventsInfo = state.currentEvents.map( item => {
      return {
        start: item.startStr,
        end: item.endStr
      }
    } );

    dispatch(multiBookingAction(eventsInfo));
    navigate('/createmultibooking');
  }

  return (
    <>
      <Grid container className='demo-app' sx={{ justifyContent: 'center' }}>
        {
          showDeleteModal &&
            <DangerModal view='invalidDate' />
        }
        <Grid container className='demo-app-sidebar' sx={{ justifyContent: 'center', mb: 4 }}>
          <Grid item xs={10} className='demo-app-sidebar-section'>
            <h2 style={{ fontFamily: 'Roboto-Thin', marginBottom: '1rem'}}>Reservas ({state.currentEvents.length})</h2>
            {
              showMessage &&
                <SuccessAlert sx={{ mb: 4, textAlign: 'center', justifyContent: 'center' }}>Felicidades! Reservas creadas exitosamente.</SuccessAlert>
            }
            <Grid container sx={{ mt: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'primary.light', borderRadius: '1rem', color: '#FFF', px: 2 }}>
              <Grid item xs={12}>
                <p style={{ margin: '.5rem 0', fontFamily: 'Roboto-Bold' }}>Check-in - Check-out:</p>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {
                  ( state.currentEvents.length > 0 ) ?
                  <ul style={{ paddingLeft: '1rem' }}>
                    {state.currentEvents.map(renderSidebarEvent)}
                  </ul>
                  :
                  <p>No hay reservas creadas</p>
                }
                {
                  state.currentEvents.length > 0 &&
                    <SecondaryButton onClick={ () => createReservations(state.currentEvents) } sx={{ mx: 4 }}>Reservar</SecondaryButton>
                }
              </Grid>
              <Grid item xs={2}>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={10} className='demo-app-main'>
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay'
            }}
            initialView='dayGridMonth'
            locale={esLocale}
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={state.weekendsVisible}
            initialEvents={INITIAL_EVENTS} // alternatively, use the `events` setting to fetch from a feed
            select={handleDateSelect}
            eventContent={renderEventContent} // custom render function
            eventClick={handleEventClick}
            eventsSet={handleEvents} // called after events are initialized/added/changed/removed
            eventChange={ () => alert('changing...') }
            /* you can update a remote database when these fire:
            eventAdd={function(){}}
            eventChange={function(){}}
            eventRemove={function(){}}
            */
          />
        </Grid>
      </Grid>
    </>
  )
}

export default MultiBooking